import { COLUMN_DATA_TYPES } from "../../../constants/constants";

//lables
export const METERING_LABELS = {
  contractedCapacity: "Contracted Capacity",
  usedBillableCapacity: "Billable Capacity",
  capacitySummary: "Capacity Summary",
  capacityDetails: "Capacity Details",
  subscriptionPeriod: "Subscription Period",
  renewalIn: "Renewal in",
  used: "Billed",
  contracted: "Contracted",
  gib: "GiB",
  months: "Months",
  days: "Days",
  noDataText: "No data is available yet. It will appear here when it's ready.",
  contracts: "Contracts",
  noContractsIntuser: "You must add a customer asset before continuing.",
  selectCustomers: "Select Customers",
  searchPlaceHolder: "Customer Name or Serial"
};

export const METERING_UI_PARAMS = {
  CLIENT_ID: "client_id",
  SERIAL_NUMBER: "serial_number",
  SITE_ID: "site_id",
  FROM_DATE: "from_date",
  TO_DATE: "to_date"
};

export const CONTRACT_FIELD_KEYS = {
  ACCOUNT_NAME: "account_name",
  SERIAL_NUMBER: "serial_number",
  SITE_ID: "site_id",
  SERVICE_LEVEL: "service_level",
  CONTRACTED_GIB: "contracted_gib",
  BILLED_GIB: "billed_gib",
  UTIL_PERCENTAGE: "util_percentage",
  CONTRACT_STATUS: "contract_status",
  POOL_ID: "pool_id",
  DATE: "date",
  CREATED: "created",
  MESSAGE: "message"
};

//Table headers
export const CAPACITY_DETAILS_COLUMNS = [
  { id: CONTRACT_FIELD_KEYS.SITE_ID, label: "Site" },
  { id: CONTRACT_FIELD_KEYS.SERIAL_NUMBER, label: "Serial" },
  { id: CONTRACT_FIELD_KEYS.POOL_ID, label: "Pool" },
  { id: CONTRACT_FIELD_KEYS.SERVICE_LEVEL, label: "Service Level" },
  {
    id: CONTRACT_FIELD_KEYS.DATE,
    label: "Date"
  },
  {
    id: CONTRACT_FIELD_KEYS.CONTRACTED_GIB,
    label: "Contracted (GiB)",
    align: "right",
    type: COLUMN_DATA_TYPES.NUMBER
  },
  {
    id: CONTRACT_FIELD_KEYS.BILLED_GIB,
    label: "Billed (GiB)",
    align: "right",
    type: COLUMN_DATA_TYPES.NUMBER
  },
  {
    id: CONTRACT_FIELD_KEYS.UTIL_PERCENTAGE,
    label: "Util %",
    align: "right",
    type: COLUMN_DATA_TYPES.NUMBER
  },
  { id: CONTRACT_FIELD_KEYS.CONTRACT_STATUS, label: "Contract Status" }
];

export const CONTRACTS_COLUMNS = [
  {
    id: CONTRACT_FIELD_KEYS.ACCOUNT_NAME,
    label: "Customer Name",
    secondarySortColumn: CONTRACT_FIELD_KEYS.SERIAL_NUMBER
  },
  { id: CONTRACT_FIELD_KEYS.SERIAL_NUMBER, label: "Serial" },
  { id: CONTRACT_FIELD_KEYS.SITE_ID, label: "Site" },
  { id: CONTRACT_FIELD_KEYS.SERVICE_LEVEL, label: "Service Level" },
  {
    id: CONTRACT_FIELD_KEYS.CONTRACTED_GIB,
    label: "Contracted (GiB)",
    align: "right",
    type: COLUMN_DATA_TYPES.NUMBER
  },
  {
    id: CONTRACT_FIELD_KEYS.BILLED_GIB,
    label: "Billed (GiB)",
    align: "right",
    type: COLUMN_DATA_TYPES.NUMBER
  },
  {
    id: CONTRACT_FIELD_KEYS.UTIL_PERCENTAGE,
    label: "Util %",
    align: "right",
    type: COLUMN_DATA_TYPES.NUMBER
  },
  { id: CONTRACT_FIELD_KEYS.CONTRACT_STATUS, label: "Contract Status" }
];

export const ADD_ASSET_CONFIRMATION_COLUMNS = [
  { id: CONTRACT_FIELD_KEYS.SITE_ID, label: "Site ID", align: "center" },
  {
    id: CONTRACT_FIELD_KEYS.SERIAL_NUMBER,
    label: "Serial Number",
    align: "center"
  },
  { id: CONTRACT_FIELD_KEYS.CREATED, label: "Results", align: "center" }
];

//Default values
export const CONTRACTED_CAPACITY_DEFAULT = {
  capacityGiB: 0,
  subscriptionPeriodMonths: 0,
  renewalInDays: 0
};

export const USED_BILLABLE_CAPACITY_DEFAULT = {
  billed_gib: 0,
  contracted_gib: 0,
  util_percentage: 0
};

//Grid columns css for mobile and tiny screens
export const GRID_COLUMNS = {
  CAPACITY_TABLE: {
    tiny: "0.6fr 1fr 32px",
    mobile: "1fr 1fr 1fr 32px"
  },
  CONTRACT_TABLE: {
    tiny: "1.5fr 1fr 32px",
    mobile: "2fr 1fr 1fr 32px"
  }
};
